import groq from 'groq';

import { QUOTE } from './quote';

export const QUOTE_CAROUSEL = groq`
  _type,
  title,
  quotes[] -> {
    ${QUOTE}
  }
`;

export const QUOTE_CAROUSEL_BLOCK = groq`
  _type == 'timeline_quoteCarousel' => {
    ${QUOTE_CAROUSEL}
  }
`;
